export const COUNTRY_CODES = ["ES","AF","AL","DZ","AS","AD","AO","AI","AQ","AG","AR","AM","AW","AU","AT","AZ","BS","BH","BD","BB","BY","BE","BZ","BJ","BM","BT","BO","BQ","BA","BW","BV","BR","IO","BN","BG","BF","BI","CV","KH","CM","CA","KY","CF","TD","CL","CN","CX","CC","CO","KM","CD","CG","CK","CR","HR","CU","CW","CY","CZ","CI","DK","DJ","DM","DO","EC","EG","SV","GQ","ER","EE","SZ","ET","FK","FO","FJ","FI","FR","GF","PF","TF","GA","GM","GE","DE","GH","GI","GR","GL","GD","GP","GU","GT","GG","GN","GW","GY","HT","HM","VA","HN","HK","HU","IS","IN","ID","IR","IQ","IE","IM","IL","IT","JM","JP","JE","JO","KZ","KE","KI","KP","KR","KW","KG","LA","LV","LB","LS","LR","LY","LI","LT","LU","MO","MG","MW","MY","MV","ML","MT","MH","MQ","MR","MU","YT","MX","FM","MD","MC","MN","ME","MS","MA","MZ","MM","NA","NR","NP","NL","NC","NZ","NI","NE","NG","NU","NF","MK","MP","NO","OM","PK","PW","PS","PA","PG","PY","PE","PH","PN","PL","PT","PR","QA","RO","RU","RW","RE","BL","SH","KN","LC","MF","PM","VC","WS","SM","ST","SA","SN","RS","SC","SL","SG","SX","SK","SI","SB","SO","ZA","GS","SS","LK","SD","SR","SJ","SE","CH","SY","TW","TJ","TZ","TH","TL","TG","TK","TO","TT","TN","TR","TM","TC","TV","UG","UA","AE","GB","UM","US","UY","UZ","VU","VE","VN","VG","VI","WF","EH","YE","ZM","ZW","AX"];

/* Exportada: la usa también el listado de llamadas para poner la bandera del
   país de quien llama. Estaba aquí privada y era la misma cuenta. */
export function flagFromCode(code) {
  return String(code || "")
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}

function buildDisplayNames(locale = "es") {
  if (typeof Intl === "undefined" || typeof Intl.DisplayNames !== "function") {
    return null;
  }

  return new Intl.DisplayNames([locale], { type: "region" });
}

export function buildCountryOptions(locale = "es") {
  const displayNames = buildDisplayNames(locale);

  return COUNTRY_CODES.map((code) => {
    const name = displayNames?.of(code) || code;
    const flag = flagFromCode(code);

    return {
      code,
      name,
      flag,
      label: `${flag} ${name}`,
    };
  }).sort((a, b) => a.name.localeCompare(b.name, locale));
}

export function countryNameFromCode(code, locale = "es") {
  if (!code) return "";

  const displayNames = buildDisplayNames(locale);
  return displayNames?.of(String(code).toUpperCase()) || String(code).toUpperCase();
}
